import { MakeCall } from './createMakeCall';
import { NotificationStatus } from './types/Notifications';

const getNotificationStatus = (makeCall: MakeCall) => () =>
  makeCall<NotificationStatus>('GET', `/api/v2/notifications/status`);
export { getNotificationStatus };
